import { render, staticRenderFns } from "./ChatTimer.vue?vue&type=template&id=44cc5bf7&scoped=true&"
import script from "./ChatTimer.vue?vue&type=script&lang=js&"
export * from "./ChatTimer.vue?vue&type=script&lang=js&"
import style0 from "./ChatTimer.vue?vue&type=style&index=0&id=44cc5bf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc5bf7",
  null
  
)

export default component.exports